export default __webpack_public_path__ + "static/media/flag.7f8e816b.svg";